import { $ABTest } from '@lemon8/web-app-shared/atom';
import { atom } from 'jotai';
import _get from 'lodash/get';

export const $LibraOptimizeSilentAwaken = atom<boolean>((get) => {
  const { parameters } = get($ABTest);

  if (__BUILD_TYPE__ === 'local_dev') {
    return true;
  }

  return _get(parameters, ['web', 'sharing', 'optimize_silent_awaken'], true);
});
